/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Projection_Chart_LabelInputs */

const en_onboarding_v1_projection_chart_label = /** @type {(inputs: Onboarding_V1_Projection_Chart_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ten-year growth comparison`)
};

const de_onboarding_v1_projection_chart_label = /** @type {(inputs: Onboarding_V1_Projection_Chart_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergleich des Wachstums über zehn Jahre`)
};

const pt_br2_onboarding_v1_projection_chart_label = /** @type {(inputs: Onboarding_V1_Projection_Chart_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparação de crescimento em dez anos`)
};

const tr_onboarding_v1_projection_chart_label = /** @type {(inputs: Onboarding_V1_Projection_Chart_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On yıllık büyüme karşılaştırması`)
};

const zh_cn2_onboarding_v1_projection_chart_label = /** @type {(inputs: Onboarding_V1_Projection_Chart_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`十年增长对比`)
};

const zh_hk2_onboarding_v1_projection_chart_label = /** @type {(inputs: Onboarding_V1_Projection_Chart_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`十年增長比較`)
};

const ko_kr2_onboarding_v1_projection_chart_label = /** @type {(inputs: Onboarding_V1_Projection_Chart_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10년 성장 비교`)
};

const ru_ru2_onboarding_v1_projection_chart_label = /** @type {(inputs: Onboarding_V1_Projection_Chart_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сравнение роста за десять лет`)
};

const es_419_onboarding_v1_projection_chart_label = /** @type {(inputs: Onboarding_V1_Projection_Chart_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparación de crecimiento a diez años`)
};

/**
* | output |
* | --- |
* | "Ten-year growth comparison" |
*
* @param {Onboarding_V1_Projection_Chart_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_projection_chart_label = /** @type {((inputs?: Onboarding_V1_Projection_Chart_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Projection_Chart_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_projection_chart_label(inputs)
	if (locale === "de") return de_onboarding_v1_projection_chart_label(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_projection_chart_label(inputs)
	if (locale === "tr") return tr_onboarding_v1_projection_chart_label(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_projection_chart_label(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_projection_chart_label(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_projection_chart_label(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_projection_chart_label(inputs)
	return es_419_onboarding_v1_projection_chart_label(inputs)
});